import React from "react";
import "./Loading.css";

const Loading = () => {
  return <div className="loading-spinner"></div>;
};

export default Loading;
